import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state.tsx";
import { useEffect, useState } from 'react';
import { selectActiveRole } from '../../../state/UserStatesV2/userSliceV2.ts';
import { openModal } from '../../../state/ModalSlice/ModalSlice.ts';

export default function ForceSwitchUserModal() {
    const Dispatch = useAppDispatch();
    const [open, setOpen] = useState(false)
    const userSliceV2 = useAppSelector((state: RootState) => state.userSliceV2.data);
    const allowRoleSwitchToOwner = userSliceV2?.allowRoleSwitchToOwner;
    const activeRole = useAppSelector(selectActiveRole);
    const role = activeRole?.role;


    useEffect(() => {
        const hasRoles = userSliceV2 && userSliceV2.myRoles && userSliceV2.myRoles.length > 0;
        const isOwner = !role;
        if (hasRoles && !allowRoleSwitchToOwner && isOwner) {
            setOpen(true)
        } else {
            setOpen(false)
        }

    }, [userSliceV2,role])





    const openRoleSwitchModal = () => {
        Dispatch(openModal("RoleSwitchModalOpen"))
    }


    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },

            }}
            maxWidth="md"
            open={open}
            disableEscapeKeyDown
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: "60px", paddingY: "40px" }} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Please Switch User</p>
                </div>

                <div className={"pt-0"}>
                    <p>You are not allowed to use owner mode, Please switch to a different role to continue.</p>
                </div>

                <div className={"flex gap-2 pt-8"}>
                    <button
                        onClick={openRoleSwitchModal}
                        className={"w-full bg-cc_brand text-white p-1.5  gap-2 rounded-lg border-gray-500 flex justify-center items-center"}
                    >
                        
                        Switch Role

                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}